import { Dialog } from '@buffer-mono/popcorn'

import InstagramSelectAccountType from '../../../../exports/Orchestrator/channelConnections/components/InstagramSelectAccountType/InstagramSelectAccountType'
import type { OnRedirectParams } from '../../../../exports/Orchestrator/channelConnections/types'
import { useModalManager } from '../../../ModalManager/hooks/useModalManager'
import { redirectToUrl } from '../../../../common/utils/urls'

import type { JSX } from 'react'

export function InstagramSelectAccountTypeDialog(): JSX.Element {
  const onRedirect = (args: OnRedirectParams): void => {
    const { redirectUrl } = args
    redirectToUrl(redirectUrl)
  }

  const { modalData: data, dismissModal: closeAction } = useModalManager()

  return (
    <Dialog
      open
      onOpenChange={(): void => {
        // custom close action
        if (data?.onCustomCloseAction) {
          data.onCustomCloseAction()
        }

        // default close action to dismiss modal
        closeAction()
      }}
    >
      <Dialog.Content size="xlarge">
        <InstagramSelectAccountType onRedirect={onRedirect} />
      </Dialog.Content>
    </Dialog>
  )
}

export default InstagramSelectAccountTypeDialog
